// Resolves a CSS custom property (e.g. '--selection') to its live computed
// value, for the few spots that can't reference it directly — Canvas 2D
// drawing (strokeStyle/fillStyle only accept real color strings, never
// var(...)) and Fabric.js canvas option objects (set once at construction,
// not re-read from the stylesheet, and parsed by Fabric's OWN regex-based
// color parser — which understands plain hex/rgb/rgba/hsl but NOT modern CSS
// functions like color-mix(), so never hand Fabric a color-mix() string).
// Every other component should just write var(--selection) etc. directly in
// its style prop; only reach for this where that isn't possible.
export function resolveCssVar(varName: string, fallback: string): string {
  if (typeof document === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
  return value || fallback;
}

// Plain hex -> rgba(...) string, for callers (Fabric.js option objects, Canvas
// 2D context) that need a real alpha-blended color literal rather than a CSS
// color-mix()/custom-property reference their parser can't understand.
export function hexToRgba(hex: string, alpha: number): string {
  const h = hex.replace('#', '');
  const full = h.length === 3 ? h.split('').map(c => c + c).join('') : h;
  const num = parseInt(full, 16) || 0;
  const r = (num >> 16) & 255, g = (num >> 8) & 255, b = num & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
